import script from "./CustomizeSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomizeSidebar.vue?vue&type=script&setup=true&lang=js"

import "./CustomizeSidebar.vue?vue&type=style&index=0&id=9bea4728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bea4728"]])

export default __exports__